// Set for deletion (to global)


export function setHideDiv(id: string, show: boolean | string, inverse?: boolean): void {

    let showBool: boolean = false;

    switch (typeof show) {

        case 'string':
            showBool = show.toLowerCase() === "true";
            break;

        case 'boolean':
            showBool = show;
            break;
    }

    if (inverse !== undefined && inverse) {
        showBool = !showBool;
    }

    const element = document.getElementById(id);

    if (element !== undefined && element !== null) {

        if (showBool) {
            element.style.display = "block";  // "inline";
        } else {
            element.style.display = "none";
        }
    }

    $("#" + id + " input").attr("data-validate", showBool.toString());
}

export function setHideDivBootstrap(id: string, show: boolean | string, inverse?: boolean): void {
    let showBool: boolean = false;

    switch (typeof show) {

        case 'string':
            showBool = show.toLowerCase() === "true";
            break;

        case 'boolean':
            showBool = show;
            break;
    }

    if (inverse !== undefined && inverse) {
        showBool = !showBool;
    }

    const element = $("#" + id);

    if (element !== undefined && element !== null) {

        if (showBool) {
            element.removeClass('d-none');
        } else {
            element.addClass('d-none');
        }
    }
}

export function setHideKendoUIFormItem(id: string, show: boolean | string, inverse?: boolean): void {
    let showBool: boolean = false;

    switch (typeof show) {

        case 'string':
            showBool = show.toLowerCase() === "true";
            break;

        case 'boolean':
            showBool = show;
            break;
    }

    if (inverse !== undefined && inverse) {
        showBool = !showBool;
    }

    const element = $("#" + id).closest("div").parent().closest("div");

    if (element !== undefined && element !== null) {

        if (showBool) {
            element.css("display", "inline-flex");
        } else {
            element.css("display", "none");
        }
    }
}

//
// This method uses the hidden attribute to hide form controls
// 
export function setHideKendoUIFormItem2(id: string, show: boolean | string): void {

    const element = document.getElementById(id).parentElement.parentElement.closest("div.k-form-field");

    if (element !== undefined && element !== null) {

        if (show) {
            // remove attribute 'hidden'
            element.removeAttribute("hidden");
        } else {
            // add attribute 'hidden'
            element.setAttribute("hidden", "hidden");
        }
    }
}

//
// This method uses the hidden attribute of the first div above the input (id) and of the label (id+'-form-label') to hide form controls
//
export function setHideKendoUIFormItem3(id: string, show: boolean | string): void {

    let element = document.getElementById(id).parentElement.parentElement;

    if (element !== undefined && element !== null) {

        if (show) {
            // remove attribute 'hidden'
            element.removeAttribute("hidden");
        } else {
            // add attribute 'hidden'
            element.setAttribute("hidden", "hidden");
        }
    }

    // label
    const id2 = id + "-form-label";
    element = document.getElementById(id2);

    if (element !== undefined && element !== null) {

        if (show) {
            // remove attribute 'hidden'
            element.removeAttribute("hidden");
        } else {
            // add attribute 'hidden'
            element.setAttribute("hidden", "hidden");
        }
    }
}

//
// For taghelper items not in taghelper-form, form with bootstrap
//
export function setHideKendoUIFormItem4(id: string, show: boolean | string): void {

    let element = document.getElementById(id);

    if (element != null && element != undefined) {

        if (show) {
            // remove attribute 'hidden'
            element.parentElement.parentElement.removeAttribute("hidden");
        } else {
            // add attribute 'hidden'
            element.parentElement.parentElement.setAttribute("hidden", "hidden");
        }
    }

    // label
    const id2 = id + "_label";
    element = document.getElementById(id2);

    if (element != null && element != undefined) {

        if (show) {
            // remove attribute 'hidden'
            element.removeAttribute("hidden");
        } else {
            // add attribute 'hidden'
            element.setAttribute("hidden", "hidden");
        }
    }
}

//
// Hides an element directly below a div
//
export function setHideKendoUIFormItem5(id: string, show: boolean | string): void {

    const element = document.getElementById(id);

    if (element != null && element != undefined) {

        if (show) {
            // remove attribute 'hidden'
            element.parentElement.removeAttribute("hidden");
        } else {
            // add attribute 'hidden'
            element.parentElement.setAttribute("hidden", "hidden");
        }
    }
}

export function getKendoCheckBoxGroupValue(cg_ID: string): number {
    let result = 0;
    const cg = $("#" + cg_ID).data("kendoCheckBoxGroup");
    if (cg != null && cg != undefined) {
        const cg_ValArr = cg.value();
        for (let i = 0; i < cg_ValArr.length; i++) {
            result += parseInt(cg_ValArr[i]);
        }
    }
    return result;
}

export function makeResultMessage(responseData: any | undefined | null) {

    var color = 'black';
    if (responseData == undefined || responseData == null) {
        $('#Validation').text('');
    }
    else {
        if (responseData.Succesfully != undefined) {
            color = (responseData.Succesfully ? 'blue' : 'red');
            if (responseData.Message == undefined || responseData.Message == null) {
                responseData.Message = (responseData.Succesfully ? "Saved" : "Error");         // TODO: translate
            }
            $('#Validation').attr('style', 'color:' + color);
            $('#Validation').text(responseData.Message);
        }
    }
    return color;
}

/*--- dialog popup ---*/
export function openActionsDialog(titleDialog: string, contentDialog: string, actions: any, height?: number, width?: number, cssclass?: string): void {
    titleDialog = decodeHtmlEntity(decodeURIComponent(titleDialog));
    contentDialog = decodeHtmlEntity(decodeURIComponent(replaceAll(contentDialog, "\r\n", "<br />")));

    addDialogDiv();
    if (height == undefined || height <= 0) { height = 160; }
    if (width == undefined || width <= 0) { width = 450; }
    $("#dialog").kendoDialog({
        modal: true,
        title: titleDialog,
        height: height,
        width: width,
        content: contentDialog,
        actions: actions
    });

    // draggable is unknown ?
    // $(".k-dialog").draggable({ handle: ".k-dialog-titlebar", containment: "parent" });
    if (cssclass != undefined) { $("#dialog").addClass(cssclass); }

    const btn = $("button.k-button.k-button-md.k-rounded-md.k-button-solid.k-button-solid-primary")
    if (btn.length) {
        btn.trigger("focus");
    }
}

export function decodeHtmlEntity(str: string): string {
    return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
    });
}

export function replaceAll(valueStr: string, search: string, replacement: string): string {
    if (valueStr != undefined || valueStr != null) {
        return valueStr.split(search).join(replacement);
    } else {
        return valueStr;
    }
}

export function addDialogDiv(): void {
    if ($("#dialog").length == 0) { $(document.body).append("<div id='dialog'></div>"); }
    else { $("#dialog").html(""); }
}

export function openPopup(): void {
    $("#dialog").data("kendoDialog").open();
}

export function closePopup(): void {
    if ($("#dialog").data("kendoDialog") !== undefined && $("#dialog").data("kendoDialog") !== null) {
        $("#dialog").data("kendoDialog").close();
    }

    kendo.destroy($("#dialog"));
}


function getParameterByName(name: string, url?: string): string | null {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function getTargetFromUrl(url?: string): string | null {
    return getParameterByName("target", url);
}

var numberrequests: number = 0;
var timeoutExecution: NodeJS.Timeout;

export function setupAjax(): void {
    $.xhrPool = {
        pool: [],

        abortAllOnError: function () {
            $.xhrPool.pool
                .filter(jqXHR => jqXHR.responseText !== undefined && jqXHR.responseText.indexOf('Account/Login') === -1)
                .forEach(abortAndRemoveFromPool);
        },

        abortAll: function () {
            $.xhrPool.pool.forEach(abortAndRemoveFromPool);
        },

        //Abort pending requests on the same target(pane)
        abortByTarget: function (target: string) {
            if (target === undefined || target === null || target === "")
                return;

            $.xhrPool.pool
                .filter(jqXHR => jqXHR.target === target)
                .forEach(abortAndRemoveFromPool);
        }
    };

    function abortAndRemoveFromPool(jqXHR: MyJqXHR<any>, index: number): void {
        jqXHR.abort();  //  aborts connection
        $.xhrPool.pool.splice(index, 1); //  removes from list by index
    }

    $.ajaxSetup({
        beforeSend: function (jqXHR: MyJqXHR<any>) {
            jqXHR.target = getTargetFromUrl(this.url);
            var showLoadIndicator = true; // default show load indicator
            // get parameter if disabled.
            if (this.disableLoadIndicator === true) {
                showLoadIndicator = false;
            }
            $.xhrPool.abortByTarget(jqXHR.target);
            $.xhrPool.pool.push(jqXHR);

            // clean any tooltip (can cause future problems including not responding tooltips elsewhere).
            $('.k-chart-tooltip').remove();

            // When enabled (load indicator)
            if (showLoadIndicator) {
                // Load indicator jquery ajax calls (first)
                if (numberrequests <= 0) {
                    numberrequests = 0; // reset!
                    kendo.ui.progress($("#moduleLayout"), true);
                    clearTimeout(timeoutExecution);
                    timeoutExecution = setTimeout(function () { numberrequests = 0; kendo.ui.progress($("#moduleLayout"), false); }, 30000);
                }
                numberrequests++;
            }
        },
        error: function () {
            $.xhrPool.abortAllOnError();
            clearTimeout(timeoutExecution);
        },
        complete: function (jqXHR) {
            var i = $.xhrPool.pool.indexOf(jqXHR);   //  get index for current connection completed
            if (i > -1) $.xhrPool.pool.splice(i, 1); //  removes from list by index
            numberrequests--;
            if (numberrequests <= 0) {
                numberrequests = 0;
                kendo.ui.progress($("#moduleLayout"), false);
                clearTimeout(timeoutExecution);
            }
        }
    });
}